import styled, { css } from 'styled-components';
import { typography } from 'src/config/typography';
import { media } from 'src/config/breakpoints';

export const AuthText = styled.div`
  font-family: ${typography.fontFamilyHeaders};
  grid-area: text;
  margin-top: 1.3125rem;

  ${media.w.min.px576(css`
    justify-self: center;
    max-width: 18.75rem;
    text-align: center;
  `)};

  ${media.w.min.px992(css`
    justify-self: start;
    margin-top: 1.45vw;
    text-align: left;
  `)};

  ${media.w.min.px1440(css`
    margin-top: 1.3125rem;
  `)};
`;
